import { useQuery } from "@tanstack/react-query";

import { ITRepairInfoService as repairToolsApis } from "../../../../../services/it-repair/itRepairInfo.service";
// import { useSelector } from "../../../../../store/store";
import {
  getStatusBaseOnApprover,
  getStepBaseOnApprover,
} from "../../delete-user-account/utils";
import { transformRequestStatus } from "../../../utils";
import { useSelector } from "../../../../../store/store";

export const useRepairToolsRequests = () => {
  const user = useSelector((state) => state.user);
  const userEmail = user?.current?.username;
  const email = 'thiennv@viags.vn';

  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["repair-tools-requests"],
    queryFn: () => repairToolsApis.getITRepairInfos(email),
  });

  const { data: data2 = [] } = useQuery<Array<any>>({
    queryKey: ["repair-tools-requests2"],
    queryFn: () => repairToolsApis.getITRepairInfos(userEmail),
  });

  const repairToolsMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === userEmail.toLowerCase()
  );

  const mappedRepairToolsRequests = data.map((record) => {
    const status = getStatusBaseOnApprover(record.fields, email);
    const step = getStepBaseOnApprover(record.fields, email);
    return {
      ...record.fields,
      id: record.id,
      createdByEmail: record.createdBy.user.email,
      createdByName: record.createdBy.user.displayName,
      createdDateTime: record.createdDateTime,
      eRequestStatus: transformRequestStatus(status, { step }),
    };
  }).sort((a,b) => b.id - a.id);

  const mappedRepairToolsRequests2 = data2.map((record) => {
    const status = getStatusBaseOnApprover(record.fields, email);
    const step = getStepBaseOnApprover(record.fields, email);
    return {
      ...record.fields,
      id: record.id,
      createdByEmail: record.createdBy.user.email,
      createdByName: record.createdBy.user.displayName,
      createdDateTime: record.createdDateTime,
      eRequestStatus: transformRequestStatus(status, { step }),
    };
  }).sort((a,b) => b.id - a.id);

  const mappedRepairToolsMyRequests = mappedRepairToolsRequests.filter(
    (record) => record.createdByEmail.toLowerCase() === userEmail.toLowerCase()
  ).sort((a,b) => b.id - a.id);

  const guideLink = "https://drive.google.com/file/d/1qIx6gNdagOl6rR3NugIMtgZCp9Op-czS/view"

  return {
    ...restResponse,
    repairToolsRequests: data,
    repairToolsMyRequests,
    mappedRepairToolsRequests,
    mappedRepairToolsMyRequests,
    mappedRepairToolsRequests2,
    guideLink,
  };
};
